// Zugriff auf die Schnittstelle; ändernde Anfragen tragen den Kopf x-anfrage (Schutz gegen fremde Ursprünge)

export class ApiFehler extends Error {
  constructor(message: string, public status: number) { super(message); }
}

export const NICHT_ANGEMELDET = 'neuratek:nicht-angemeldet';

export async function api<T>(pfad: string, optionen: { methode?: 'GET' | 'POST' | 'PUT' | 'DELETE'; daten?: unknown } = {}): Promise<T> {
  const methode = optionen.methode ?? 'GET';
  const antwort = await fetch(pfad, {
    method: methode,
    credentials: 'same-origin',
    headers: methode === 'GET' ? {} : { 'Content-Type': 'application/json', 'x-anfrage': 'neuratek' },
    body: optionen.daten === undefined ? undefined : JSON.stringify(optionen.daten)
  });
  const inhalt = (await antwort.json().catch(() => ({}))) as { fehler?: string };
  if (!antwort.ok) {
    if (antwort.status === 401 && pfad !== '/api/ich' && !pfad.startsWith('/api/anmeldung')) window.dispatchEvent(new Event(NICHT_ANGEMELDET));
    throw new ApiFehler(inhalt.fehler ?? `Anfrage fehlgeschlagen (${antwort.status}).`, antwort.status);
  }
  return inhalt as T;
}
